import { MOCK_LOGOUT_SUCCESS_RESPONSE } from './config';

export const api = {
  logout: async function (accessToken) {
    return new Promise((resolve) => {
      resolve(MOCK_LOGOUT_SUCCESS_RESPONSE);
    });
  },
};
